import React, { useEffect, useState, useRef } from "react";
import moment from "moment-timezone";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useRecoilState, useRecoilValue } from "recoil";
import styled from "styled-components";
import { langState, langText } from "../../recoil/lang";
import "../../styles/CustomModal.css";
import { ConciergeRequestType } from "../../controller/ConciergeController";
import ApiController from "../../controller/ApiController";
import { authState, masterStoreState } from "../../recoil/auth";
import { useToast } from "../../controller/ToastController";
import { csChatState, chatType, storeChatState } from "../../recoil/chat";
import { getRecoil, resetRecoil } from "recoil-nexus";
import { ChatDetailType } from "../../controller/DirectMessageController";
import { showKeyboardState } from "../../recoil/showKeyboard";
import LogController from "../../controller/LogController";

interface StoreChatModalProps {
  isVisible: chatType;
  chatDetail: ChatDetailType[];
  setChatDetail: any;
}

const StoreChatModal = ({
  isVisible,
  chatDetail,
  setChatDetail,
}: StoreChatModalProps) => {
  const showToast = useToast();
  const textareaRef = useRef<any>(null);
  const auth = useRecoilValue(authState);
  const chatEndRef = useRef<HTMLDivElement | null>(null);
  const [lang, setLang] = useRecoilState<number>(langState);
  const [message, setMessage] = useState<string>("");
  const [onKeyboard, setOnKeyboard] = useState<boolean>(false);
  const [showKeyboard, setShowKeyboard] = useRecoilState(showKeyboardState);

  const scrollToBottom = () => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const changeMessage = (e: any) => {
    setMessage(e.target.value);
  };

  const onCloseModal = () => {
    resetRecoil(storeChatState);
  };

  // 컨시어지 요청
  const writeMessage = async () => {
    if (message === "") {
      showToast(langText.responseModal_input_placeholder[lang], "error");
    } else {
      try {
        const oParams = {
          cs_id: isVisible.cs_id,
          message: message,
          sender_type: "ROOM",
          lang: lang,
          user_token_id: auth.user_token_id,
        };
        setMessage("");

        const response = await ApiController.chat.writeMessage(oParams);

        if (response && response.data.status === 200) {
          const newMessage = {
            sender_type: "ROOM",
            read: 1,
            created_at: new Date(),
            read_at: null,
            chat: message,
          };
          setChatDetail([...chatDetail, newMessage]);
          scrollToBottom();
        } else {
          showToast(langText.responseModal_failed[lang], "error");
        }
      } catch (err) {
        console.log("writeMessage err-->", err);
      }
    }
  };
  const finishChat = async () => {
    try {
      console.log("finishChat", isVisible);

      const oParams = {
        cs_id: isVisible.cs_id,
        sender_type: "ROOM",
        user_token_id: auth.user_token_id,
      };
      const response = await ApiController.chat.finishChat(oParams);

      if (response && response.data) {
        showToast(langText.finish_chat[lang]);
        onCloseModal();

        LogController.click({
          path: "StoreChatModal",
          params: "storeChat",
          params2: "채팅 종료 버튼 클릭",
          index: isVisible.cs_id!,
        });
      }
    } catch (err) {
      console.log("finishChat err-->", err);
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [chatDetail]);
  useEffect(() => {
    setMessage(showKeyboard.input);
  }, [showKeyboard]);

  useEffect(() => {
    setMessage("");
    if (!isVisible) {
      setChatDetail([]);
    }
  }, [isVisible]);

  return (
    <Modal
      open={isVisible.visible}
      onClose={onCloseModal}
      center
      classNames={{
        modal: "conciergeModal",
      }}
      showCloseIcon={false}
      animationDuration={150}
    >
      <Style>
        <div className="modal">
          <div className="modal_header">
            <div className="cleckButton">
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_store.svg`}
                width={42}
                height={42}
                alt="store"
              />
            </div>
            {/* <h2>{langText.responseModal_cs_title[lang]}</h2> */}
            <h2>{isVisible.area_name}</h2>
            <img
              className="closeIcon"
              onClick={onCloseModal}
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
              alt="닫기 아이콘"
            />
          </div>
          <div className="modal_content">
            <div className="chatWrap">
              {chatDetail &&
                chatDetail.map((data: ChatDetailType, index: number) => (
                  <div
                    key={index}
                    className={`sendWrap ${
                      data.sender_type === "ROOM" ? " customer" : "hotel"
                    }`}
                  >
                    {data.sender_type !== "ROOM" && (
                      <div className="iconBox">
                        <img
                          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_clerk.svg`}
                          width={18}
                          height={18}
                          alt="컨시어지 아이콘"
                        />
                      </div>
                    )}
                    {data.sender_type === "ROOM" && (
                      <h4>{`${
                        new Date(data.created_at).getHours() > 12
                          ? langText.pm[lang]
                          : langText.am[lang]
                      } ${moment(new Date(data.created_at)).format(
                        "HH:mm"
                      )}`}</h4>
                    )}
                    <p>{data.chat}</p>
                    {data.sender_type !== "ROOM" && (
                      <h4>{`${
                        new Date(data.created_at).getHours() > 12
                          ? langText.pm[lang]
                          : langText.am[lang]
                      } ${moment(new Date(data.created_at)).format(
                        "HH:mm"
                      )}`}</h4>
                    )}
                  </div>
                ))}
              <div ref={chatEndRef} style={{ marginBottom: "50px" }} />
            </div>
            <div className="textAreaWrap">
              {lang === 0 ? (
                <textarea
                  ref={textareaRef}
                  name="conciergeText"
                  id="conciergeText"
                  placeholder={langText.responseModal_input_placeholder[lang]}
                  value={message}
                  onChange={(e) => changeMessage(e)}
                  onFocus={() => setOnKeyboard(true)}
                  onBlur={() => setOnKeyboard(false)}
                />
              ) : (
                <div
                  ref={textareaRef}
                  onClick={() =>
                    setShowKeyboard((prev) => ({
                      ...prev,
                      showKeyboard: true,
                      input: message,
                    }))
                  }
                  className="textarea"
                >
                  {message || langText.conciergeModal_placeholder[lang]}
                </div>
              )}
              <button onClick={writeMessage} className="sendButton">
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_send.svg`}
                  alt="보내기 아이콘"
                />
              </button>
            </div>
          </div>
          <div style={{ height: "5px", background: "#1C1C1C" }} />
          <div className="modal_footer">
            <div className="noticeText">
              <p>{langText.responseModal_comment[lang]}</p>
            </div>
            <button onClick={finishChat}>
              {langText.responseModal_button_check[lang]}
            </button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default StoreChatModal;

const Style = styled.div`
  .modal {
    width: 100%;
    height: 100%;
  }

  /* modal_header */
  .modal_header {
    width: 100%;
    min-height: 200px;
    padding: 74px 20px 34px 20px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    white-space: pre-line;
    text-align: center;

    h2 {
      /* font-size: 24px; */
      font-size: 28px;
      line-height: 36px;
      color: #ffffff;
    }

    .closeIcon {
      position: absolute;
      top: 6%;
      right: 2%;
      cursor: pointer;
    }
  }

  /* modal_content */
  .modal_content {
    width: 100%;
    padding: 0 5%;
  }
  .chatWrap {
    height: 300px;
    padding: 10px 32px;
    overflow-y: auto;
    border: 2px solid #555;
    border-radius: 10px;
    display: inline-flex;
    flex-direction: column;
    width: 100%;

    h4 {
      font-size: 12px;
      font-weight: 500;
      color: #737373;
      margin-top: auto;
    }
  }
  .sendWrap {
    width: auto;
    margin: 10px 0;
    display: flex;
    align-items: center;
    gap: 6px;

    p {
      padding: 6px 20px;
      background: #737373;
      border-radius: 50px;
      font-size: 18px;
      font-weight: 400;
      line-height: 24px;
    }
  }
  .sendWrap.customer {
    justify-content: flex-end;
    p {
      background: #40977f;
    }
  }
  .iconBox {
    padding: 6px 7px 3px 7px;
    border-radius: 50px;
    background: #737373;
  }

  .textAreaWrap {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 30px 0;

    textarea,
    .textarea {
      flex: 1;
      padding: 11px 30px;
      background: #555;
      border-radius: 10px;
      border: none;
      outline: none;
      max-height: 40px;
      color: #979797;
    }
  }
  .textarea {
    align-items: flex-start;
    word-wrap: break-word;
  }

  /* modal_footer */
  .modal_footer {
    padding: 37px 5% 58px 5%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .noticeText {
      margin-bottom: -12px;
      padding: 6px 16px 4px 16px;
      background: #f7f7f7;
      border-radius: 50px;
      z-index: 10;

      p {
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        color: #ff4a4a;
      }
    }
    button {
      width: 100%;
      padding: 17px 0;
      font-size: 24px;
      font-weight: 600;
      color: #4dd2ae;
      border: 2px solid #4dd2ae;
      border-radius: 10px;
    }
  }

  /* 아이콘 */
  .cleckButton {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    margin-bottom: 27px;
    background: #4dd2ae;
    border-radius: 100px;
  }
  .sendButton {
    display: flex;
    align-items: center;
    padding: 8px 34px;
    border-radius: 10px;
    background: #4dd2ae;
  }

  .submitButton {
    margin-top: 10px;
    width: 100%;
    padding: 18px 0;
    background: #4dd2ae;
    border-radius: 10px;
    color: #ffffff;
    font-size: 22px;
    line-height: 30px;
    font-weight: 600;
  }
`;
